export default __webpack_public_path__ + "static/media/marathi_finan_f.610c7f00.wav";